import React, {Component} from 'react';

class SingleButton extends Component {

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.label !== nextProps.label
            || this.props.disabled !== nextProps.disabled
            || this.props.handleClick !== nextProps.handleClick
        )
    }

    render() {
        const { className } = this.props;
        const { label, handleClick, disabled } = this.props;

        return (
            <>
                <button className={className} onClick={handleClick} disabled={disabled}>{label}</button>
            </>
        )
    }
}

SingleButton.defaultProps = {
    label: '',
    handleClick: function () {},
    disabled: false,
}

export default SingleButton;
